<template>
	<div
		v-bind:class="[
			tableClasses,
			{
				'table-border': cellSize != 'big',
				'bg-white-base': cellSize != 'big',
				'elevation-8dp': cellSize != 'big'
			}
		]"
	>
		<table
			border="0"
			class="flex-row"
			v-bind:class="{
				'table-selectable': cellSize == 'big'
			}"
		>
			<thead>
				<tr>
					<th
						v-if="selectable && removeSelecteds === false"
						key="selectable"
						class="ink-base font-size-big align-left padding-left-big"
					>
						<BCheckbox v-model="allSelected" name="allSelected" />
					</th>
					<th
						v-if="selectable && removeSelecteds === true"
						key="selectable"
						class="ink-base font-size-big align-left padding-left-big"
					>
						<BCheckbox v-model="removeSelecteds" name="removeSelecteds" icon="remove" />
					</th>
					<th
						v-bind:class="{
							'padding-vertical-big': cellSize == 'big',
							'font-size-xbig': cellSize == 'big'
						}"
						class="ink-base font-size-big semi-bold align-left padding-horizontal-big padding-vertical-normal"
						v-for="{ key, value } in fields"
						:key="key"
					>
						{{ value }}
					</th>
				</tr>
			</thead>
			<tbody v-if="items.length > 0">
				<tr class="row-border" v-for="item in items" :key="item._id">
					<td
						v-if="selectable"
						key="selectable"
						class="ink-base font-size-big align-left padding-left-big padding-vertical-normal"
					>
						<BCheckbox
							v-if="item['selectable'] !== false"
							v-model="selectedsModel[item._id]"
							:name="item._id"
							@input="changeSelectedValue(item._id)"
						/>
						<BIcon class="blocked-select ink-lighter-3" v-else
							><icon-check-box-outline-blank
						/></BIcon>
					</td>
					<template v-for="{ key } in fields">
						<td
							v-bind:class="{
								'padding-vertical-big': cellSize == 'big',
								'padding-horizontal-big': cellSize == 'big'
							}"
							class="ink-base regular padding-horizontal-big padding-vertical-normal"
							v-if="typeof $scopedSlots[key] !== 'undefined'"
							:key="key"
						>
							<slot :name="key" :field="key" :item="item"></slot>
						</td>
						<td
							v-bind:class="{
								'padding-vertical-big': cellSize == 'big',
								'font-size-xbig': cellSize == 'big',
								'padding-horizontal-big': cellSize == 'big'
							}"
							class="ink-base font-size-big regular padding-horizontal-big padding-vertical-normal"
							v-else
							:key="key"
						>
							{{ item[key] }}
						</td>
					</template>
				</tr>
				<tr v-if="hasPagination" class="row-border">
					<td :colspan="fields.length">
						<b-pagination :currentPage="currentPage" :pageCount="pageCount" @loadPage="loadPageTable" />
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr>
					<td
						class="ink-base font-size-big align-left padding-left-big padding-vertical-normal no-items"
						:colspan="selectable ? fields.length + 1 : fields.length"
					>
						<slot name="noitems"></slot>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import BPagination from './Pagination.vue';
import BCheckbox from './Checkbox.vue';
import BIcon from './Icon.vue';

export default {
	name: 'b-table',
	components: {
		BPagination,
		BCheckbox,
		BIcon
	},
	data: function() {
		return {
			allSelected: false,
			removeSelecteds: false,
			selectedsModel: {},
			selecteds: []
		};
	},
	props: {
		/**
		 * Colunas da tabela
		 */
		fields: Array,
		/**
		 * Dados da tabela
		 */
		items: Array,
		/**
		 * Número de páginas totais
		 */
		pageCount: Number,
		/**
		 * Número da página atual
		 */
		currentPage: Number,
		/**
		 * Se true, tabela terá opção de seleção de linhas
		 */
		selectable: Boolean,
		/**
		 * Tamanho da célula da tabela (big ou normal)
		 */
		cellSize: {
			type: String,
			default: 'normal'
		},
		hasPagination: {
			type: Boolean,
			default: false
		},
		tableClasses: {
			type: [String, Array],
			default:
				'margin-horizontal-auto table-width margin-horizontal-tiny margin-bottom-xbig display-flex flex-column'
		}
	},
	methods: {
		cleanSelectable() {
			this.allSelected = false;
			this.removeSelecteds = false;
			this.selecteds = [];
			this.selectedsModel = {};
		},
		loadPageTable(page) {
			this.$emit('loadPageTable', page);
		},
		changeSelectedItems(selectedItems) {
			this.$emit('changeSelectedItems', selectedItems);
		},
		changeSelectedValue(elementId) {
			this.removeSelecteds = true;
			if (this.selecteds.includes(elementId)) {
				this.$set(this.selectedsModel, elementId, false);
				const index = this.selecteds.indexOf(elementId);
				this.selecteds.splice(index, 1);
				if (this.selecteds.length == 0) this.removeSelecteds = false;
			} else {
				this.$set(this.selectedsModel, elementId, true);
				this.selecteds.push(elementId);
				if (this.selecteds.length == this.items.length) {
					this.removeSelecteds = false;
					this.$nextTick(function() {
						this.allSelected = true;
					});
				}
			}
		},
		resetTableSelectionFields() {
			this.allSelected = false;
			this.removeSelecteds = false;
			this.selecteds = [];
		}
	},
	watch: {
		allSelected: function(newStatus) {
			if (newStatus === true) {
				this.items.forEach(item => {
					if (item.selectable !== false) {
						if (!this.selecteds.includes(item._id)) this.selecteds.push(item._id);
						this.$set(this.selectedsModel, item._id, true);
					}
				});
			} else {
				this.selecteds = [];
				this.selectedsModel = {};
			}
			this.changeSelectedItems(this.selecteds);
		},
		removeSelecteds: function(newStatus) {
			if (newStatus === false) {
				this.selecteds = [];
				this.selectedsModel = {};
				this.allSelected = false;
			}
			this.changeSelectedItems(this.selecteds);
		},
		selectedsModel: function() {
			this.changeSelectedItems(this.selecteds);
		}
	}
};
</script>

<style lang="scss" scoped>
table {
	border-collapse: collapse;
}

.table-border {
	border-radius: 5px;
	border: 1px solid #dcdbe1;
}

.row-border {
	border-top: solid 1px #dcdbe1;
}

.options-column {
	width: 10px;
	height: 50px;
}

.icon {
	width: 15px;
	height: 15px;
}

.table-selectable {
	border-spacing: 0px 10px;
	border-collapse: separate;
}

.table-selectable td,
.table-selectable th {
	background: #fff;
	border-top: 1px solid #dcdbe1;
	border-bottom: 1px solid #dcdbe1;
}

.table-selectable td:first-child,
.table-selectable th:first-child {
	border-radius: 5px 0 0 5px;
	border-left: 1px solid #dcdbe1;
}

.table-selectable td:last-child,
.table-selectable th:last-child {
	border-radius: 0 5px 5px 0;
	border-right: 1px solid #dcdbe1;
}

div.table-box {
	auto > div {
		width: auto;
	}
}

.blocked-select {
	font-size: 2rem;
}

.table-selectable td.no-items {
	border-radius: 5px;
}

@media (min-width: 1200px) {
	.table-width {
		width: 100%;
	}
}
</style>
